import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getPreClaimsReasonAPI = () => {
  return axiosInstance.request({
    url: `${API.PRECLAIM}/GetReason`,
    method: 'get',
  });
};

export type PreClaimsReasonResponse = {
  reasonCode: string;
  reasonCodeDesc: string;
}[];

export const fetchPreClaimsReason = async (): Promise<PreClaimsReasonResponse> => {
  const response: AxiosResponse<PreClaimsReasonResponse> = await getPreClaimsReasonAPI();
  return response.data;
};
